SP.lang.Class.define("SP.sitekit.form.field.FieldGroup", {
	extend: "SP.sitekit.form.field.Field",

	_controls: null,

	init: function (el, options) {

		var me = this;

		// SK: ".SP-Field__control" hinzugefügt, in "components" ist auch so gelöst
		this._controls = el.querySelectorAll(options.controlSelector || ".SP-Field__control");
		for (var i = 0; i < this._controls.length; i++) {
			if (!this._controls[i].hasAttribute("disabled")) {
				this._controls[i].addEventListener("blur", function () { // jshint ignore:line
					me.validate();
				});
			}
		}

		this._super.apply(this, arguments);
	},

	/**
	 * Liefert alle HTMLInputElement der Gruppe.
	 * @return HTMLInputElement[]
	 */
	getControls: function() {
		return this._controls;
	},

	getValue: function () {

		var value = null;
		for (var i = 0; i < this._controls.length; i++) {
			if (this._controls[i].checked) {
				value = this._controls[i].value;
				break;
			}
		}

		return value;
	}
});
